import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=6e2fc06e&"
import script from "./courseDetail.vue?vue&type=script&lang=js&"
export * from "./courseDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=6e2fc06e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports